import { useState, createContext, useContext } from "react";
import type { LeadSourceType } from "@/lib/commerce-types";

export type SourceFilter = "all" | LeadSourceType;

interface SourceFilterContextValue {
  sourceFilter: SourceFilter;
  setSourceFilter: (v: SourceFilter) => void;
}

const SourceFilterContext = createContext<SourceFilterContextValue>({
  sourceFilter: "all",
  setSourceFilter: () => {},
});

export function SourceFilterProvider({ children }: { children: React.ReactNode }) {
  const [sourceFilter, setSourceFilter] = useState<SourceFilter>("all");
  return (
    <SourceFilterContext.Provider value={{ sourceFilter, setSourceFilter }}>
      {children}
    </SourceFilterContext.Provider>
  );
}

/**
 * Hook to get/set source_type filter and apply it to Supabase queries.
 */
export function useSourceFilter() {
  const { sourceFilter, setSourceFilter } = useContext(SourceFilterContext);

  /** Apply source_type filter to a Supabase query. Returns query unchanged if "all". */
  function applySourceFilter(query: any, column = "source_type"): any {
    if (sourceFilter !== "all") {
      return query.eq(column, sourceFilter);
    }
    return query;
  }

  const sourceQueryKey = sourceFilter === "all" ? ["all-sources"] : [sourceFilter];

  return { sourceFilter, setSourceFilter, applySourceFilter, sourceQueryKey };
}
